module.exports = __webpack_public_path__ + "img/aktiviti-kelapa-tacunan.5d77c1c3.png";